import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';
import { getMileageValue } from '@ReactComponents/Shared/Forms/MileageFields/MileageFields';
import { AbacusCurrency } from '@Shared/helpers';
import { Api as apiService } from '../api';
export class SplitApi {
    static createSplitExpense(splitBodyData, bypassWarnings) {
        if (bypassWarnings) {
            splitBodyData.shared = Object.assign(Object.assign({}, splitBodyData.shared), { bypassWarnings: true });
        }
        const expenseData = {
            splits_data_string: encodeURIComponent(JSON.stringify(Object.assign(Object.assign({}, splitBodyData), { bypassWarnings })))
        };
        return apiService
            .post(SplitApi.splitTransactionsApiURL, expenseData)
            .then((response) => response.json());
    }
    static splitExistingExpense(splitBodyData, expense, bypassWarnings) {
        splitBodyData.shared = Object.assign(Object.assign(Object.assign({}, expense), splitBodyData.shared), { bypassWarnings: Boolean(bypassWarnings) });
        const expenseData = {
            splits_data_string: encodeURIComponent(JSON.stringify(Object.assign(Object.assign({}, splitBodyData), { bypassWarnings })))
        };
        return apiService
            .post(`/api/web/transactions/${expense.id}/split`, expenseData)
            .then((response) => response.json());
    }
    static deleteSplits(splitTransactionId) {
        return apiService.responseToJSONAndToastError(apiService.delete(SplitApi.splitTransactionsApiURL + `/${splitTransactionId}`));
    }
}
SplitApi.splitTransactionsApiURL = '/api/web/split_transactions';
SplitApi.includeWithExpenses = [
    'include[user]',
    'include[user_profile]',
    'include[venue_info]',
    'include[image]',
    'include[images]',
    'include[category]',
    'include[expense_tags]',
    'include[metadata]',
    'include[manager]',
    'include[card_transaction]',
    'include[card]',
    'include[trip]'
].join('&');
export function splitExpense(baseValues) {
    var _a, _b, _c;
    if (!baseValues) {
        return [];
    }
    const baseSplit1 = Object.assign(Object.assign({}, cloneDeep(baseValues)), { key: uuid() });
    const baseSplit2 = Object.assign(Object.assign({}, cloneDeep(baseValues)), { key: uuid() });
    // Set amount
    if (!((_a = baseValues.metadata) === null || _a === void 0 ? void 0 : _a.mileage)) {
        const currencyCode = baseValues.entered_currency_code || 'USD';
        const currencyAmountInMajor = Number(baseValues.entered_currency_amount);
        const [splitUsdAmount1, splitUsdAmount2] = new AbacusCurrency(baseValues.amount).split(2);
        const [splitCurrencyAmount1, splitCurrencyAmount2] = new AbacusCurrency(currencyAmountInMajor, currencyCode, true).split(2);
        baseSplit1.entered_currency_amount = String(splitCurrencyAmount1.getUnitValue());
        baseSplit2.entered_currency_amount = String(splitCurrencyAmount2.getUnitValue());
        baseSplit1.amount = splitUsdAmount1.getMinorUnitValue();
        baseSplit2.amount = splitUsdAmount2.getMinorUnitValue();
        baseSplit1.entered_currency_code = currencyCode;
        baseSplit2.entered_currency_code = currencyCode;
        if (baseSplit1.metadata && baseSplit2.metadata) {
            baseSplit1.metadata.currency_amount = String(splitCurrencyAmount1.getUnitValue());
            baseSplit2.metadata.currency_amount = String(splitCurrencyAmount2.getUnitValue());
        }
    }
    // Set mileage
    if ((_b = baseValues.metadata) === null || _b === void 0 ? void 0 : _b.mileage) {
        const mileageRateMinor = baseValues.metadata.mileage_rate;
        const splitMileage = parseFloat((baseValues.metadata.mileage / 2).toFixed(2));
        const mileageValue = getMileageValue(splitMileage, mileageRateMinor);
        baseSplit1.amount = mileageValue.amount;
        baseSplit1.entered_currency_amount = mileageValue.entered_currency_amount;
        baseSplit1.metadata = Object.assign(Object.assign({}, baseSplit1.metadata), mileageValue.metadata);
        const remainingSplitMileage = ((_c = baseValues.metadata) === null || _c === void 0 ? void 0 : _c.mileage) - splitMileage;
        const remainingMileageValue = getMileageValue(remainingSplitMileage, mileageRateMinor);
        baseSplit2.amount = remainingMileageValue.amount;
        baseSplit2.entered_currency_amount = remainingMileageValue.entered_currency_amount;
        baseSplit2.metadata = Object.assign(Object.assign({}, baseSplit2.metadata), remainingMileageValue.metadata);
    }
    return [baseSplit1, baseSplit2];
}
